import messages from '../../../locale/messages';
import { inputTextLimit } from '../../../helpers/fieldRestriction';

const validate = values => {
    const errors = {}

    if (!values.message) {
        errors.message = messages.messageRequired;
    } else if (values.message && values.message.toString().trim() === '') {
        errors.message = messages.messageRequired;
    } else if (values.message && values.message.length > inputTextLimit) {
        errors.message = messages.inputTextLimitError;
    }

    return errors
}

export default validate;